import React from 'react';
import PropTypes from 'prop-types';
import {
  hasBlocksData,
  flattenToAppURL,
  flattenHTMLToAppURL,
} from '@plone/volto/helpers';
import { comPrefixo } from 'volto-ministerio-publico-federal/helpers/Url/subpath';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';

const fixedBlocks = {
  blocks: {
    'fixed-related': {
      '@type': 'relatedItems',
    },
  },
  blocks_layout: {
    items: ['fixed-related'],
  },
};

const NewsItemView = ({ content }) => {
  const Container =
    config.getComponent({ name: 'Container' }).component || 'div';

  return hasBlocksData(content) ? (
    <section id="page-document" className="newsitem-view">
      <div className="container mx-auto px-4 py-8">
        <RenderBlocks content={content} />
      </div>
      <div className="container mx-auto px-4 pb-8">
        <RenderBlocks content={fixedBlocks} />
      </div>
    </section>
  ) : (
    <Container className="view-wrapper mx-auto max-w-7xl px-4 py-8">
      {content.title && (
        <h1 className="mb-4 text-on-surface-high">
          {content.title}
          {content.subtitle && ` - ${content.subtitle}`}
        </h1>
      )}
      {content.description && (
        <p className="mb-6 text-lg text-gray-600">{content.description}</p>
      )}
      {content.image && (
        <img
          className="mb-6 rounded-lg"
          alt={content.title}
          src={
            content.image['content-type'] === 'image/svg+xml'
              ? comPrefixo(flattenToAppURL(content.image.download))
              : comPrefixo(flattenToAppURL(content.image.scales.mini.download))
          }
        />
      )}
      {content.text && (
        <div
          className="mpf-content__editor-content"
          dangerouslySetInnerHTML={{
            __html: flattenHTMLToAppURL(content.text.data),
          }}
        />
      )}
    </Container>
  );
};

NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
    image: PropTypes.shape({
      download: PropTypes.string,
      'content-type': PropTypes.string,
      scales: PropTypes.shape({
        mini: PropTypes.shape({
          download: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

export default NewsItemView;
